import React from 'react';
import { SegmentedToggle } from './SegmentedToggle';

// Utility function to convert probability to American odds
export const toAmericanOdds = (probability: number): string => {
  if (probability <= 0) return "N/A";
  const prob = probability * 100;
  let odds: number;

  if (prob < 50) {
    odds = (100 / prob) * 100 - 100;
    return `+${Math.round(odds)}`;
  } else {
    odds = -(prob / (100 - prob)) * 100;
    return Math.round(odds).toString();
  }
};

interface OddsToggleProps {
  checked: boolean;
  onChange: (showAmericanOdds: boolean) => void;
  size?: 'small' | 'medium';
}

/** Probability (%) / American odds toggle shared by the Predictions and Simulator pages. */
export const OddsToggle: React.FC<OddsToggleProps> = ({ checked, onChange, size }) => (
  <SegmentedToggle
    aria-label="Show probabilities or American odds"
    size={size}
    value={checked ? 'odds' : 'prob'}
    onChange={(v) => onChange(v === 'odds')}
    options={[
      { value: 'prob', label: 'Probability' },
      { value: 'odds', label: 'Odds', title: 'American odds' },
    ]}
  />
);
